import React from 'react';
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  IconButton,
  Input,
  Text
} from '@chakra-ui/react';
import { DeleteIcon } from '@chakra-ui/icons';

const SelectedInvoiceProductsTable = ({
  entries,
  products,
  handleProductChange,
  handleRemoveEntry,
  type = 'sell',
}) => {
  // Create a map for products for faster lookup
  const productMap = products.reduce((acc, product) => {
    acc[product.id] = product;
    return acc;
  }, {});

  return (
    <Box mt="4" borderWidth="1px" borderRadius="md" p="4">
      <Table variant="striped" size="sm">
        <Thead>
          <Tr>
            <Th>Назва товару</Th>
            <Th>Кількість</Th>
            <Th>Закупочна ціна</Th>
            <Th>Відсоток націнки</Th>
            <Th>Ціна</Th>
            <Th>Загальна</Th>
            <Th>Дії</Th>
          </Tr>
        </Thead>
        <Tbody>
          {entries.map((entry) => {
            const product = productMap[entry.product_id] || {}; // Look up the product by ID
            const purchasePrice = parseFloat(entry.purchase_price);
            const markupPercentage = type === 'arrival' ? 0 : parseFloat(entry.markup_percentage);
            const price = type === 'arrival' ? purchasePrice : parseFloat(entry.price);

            // Always enforce markup = 0 for arrival
            if (type === 'arrival' && entry.markup_percentage !== 0) {
              handleProductChange(entry.product_id, 'markup_percentage', 0);
            }
            const total = type === 'arrival'
              ? entry.quantity * purchasePrice
              : entry.quantity * price;

            return (
              <Tr key={entry.product_id}>
                <Td>
                  {product.name || entry.name || 'Товар не знайдено'}
                  {product.is_vat && (
                    <Text as="span" ml="2" color="green.500" fontSize="sm">
                      (з ПДВ)
                    </Text>
                  )}
                </Td>
                <Td>
                  <Input
                    size="sm"
                    type="number"
                    value={entry.quantity}
                    onChange={(e) =>
                      handleProductChange(entry.product_id, 'quantity', e.target.value)
                    }
                  />
                </Td>
                <Td>{entry.purchase_price}</Td>
                <Td>
                  <Input
                    size="sm"
                    type="number"
                    name="markup_percentage"
                    value={markupPercentage}
                    isDisabled={type === 'arrival'}
                    onChange={(e) => {
                      if (type === 'arrival') return;
                      const newMarkup = parseFloat(e.target.value);
                      const newPrice = purchasePrice + (purchasePrice * (newMarkup / 100));
                      handleProductChange(entry.product_id, 'markup_percentage', newMarkup);
                      handleProductChange(entry.product_id, 'price', newPrice.toFixed(2));
                    }}
                  />
                </Td>
                <Td>
                  <Input
                    size="sm"
                    type="number"
                    name="price"
                    value={price}
                    onChange={(e) => {
                      const newPrice = parseFloat(e.target.value);
                      handleProductChange(entry.product_id, 'price', newPrice);
                      if (type !== 'arrival') {
                        const newMarkup = ((newPrice - purchasePrice) / purchasePrice) * 100;
                        handleProductChange(entry.product_id, 'markup_percentage', newMarkup.toFixed(2));
                      } else {
                        handleProductChange(entry.product_id, 'markup_percentage', 0);
                      }
                    }}
                  />
                </Td>
                <Td>{total.toFixed(2)}</Td>
                <Td>
                  <IconButton
                    icon={<DeleteIcon />}
                    colorScheme="red"
                    onClick={() => handleRemoveEntry(entry.product_id)}
                  />
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </Box>
  );
};

export default SelectedInvoiceProductsTable;
